import { useState } from "react";
import { PaymentElement, useCheckout } from "@stripe/react-stripe-js";

import { Button, CircularProgress, Snackbar, Alert } from "@mui/material";

export default function PaymentForm({ confirmText }) {
    const checkout = useCheckout();

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        const confirmResult = await checkout.confirm();

        // This point will only be reached if there is an immediate error.
        // Otherwise, the user will be redirected to the `return_url` set on the server,
        // which redirects back to the frontend after saving payment info.
        if (confirmResult.type === "error") {
            setError(confirmResult.error.message);
        }

        setLoading(false);
    };

    const handleCloseError = () => {
        setError("");
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" />

            <Button
                type="submit"
                variant="contained"
                size="large"
                color="primary"
                sx={{ color: "white", margin: "24px 0" }}
                fullWidth
                disabled={loading}
            >
                {loading ? <CircularProgress size={26} /> : confirmText}
            </Button>

            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                open={error != ""}
                onClose={handleCloseError}
            >
                <Alert
                    variant="filled"
                    severity="error"
                    sx={{ width: "100%" }}
                    onClose={handleCloseError}
                >
                    {error}
                </Alert>
            </Snackbar>
        </form>
    );
}
